import { render, staticRenderFns } from "./ActivityImageWidget.vue?vue&type=template&id=4fe0b7b7&scoped=true&"
import script from "./ActivityImageWidget.vue?vue&type=script&lang=js&"
export * from "./ActivityImageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0b7b7",
  null
  
)

export default component.exports